import {useContext, useEffect, useState} from 'react';

import CloseIcon from '@mui/icons-material/Close';
import {Alert, IconButton, Snackbar, SnackbarOrigin} from '@mui/material';

import {SnackBarContext, SnackBarMessage} from '../../contexts/SnackBarContext/SnackBarContext';

const Action = ({handleClose}: {handleClose: () => void}) => (
  <>
    <IconButton size='small' aria-label='close' color='inherit' onClick={handleClose}>
      <CloseIcon fontSize='small' />
    </IconButton>
  </>
);

const defaultAutoHideDuration = 6000;

const defaultAnchorOrigin: SnackbarOrigin = {
  vertical: 'top',
  horizontal: 'center',
};

export const PopupMessage = () => {
  const {message, clearMessage} = useContext(SnackBarContext);
  const [localMessage, setLocalMessage] = useState<SnackBarMessage>();
  const [isOpen, setOpen] = useState(false);

  const handleCloseSnackbar = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (message) {
      setLocalMessage(message);
      clearMessage();
      setOpen(true);
    }
  }, [message, setLocalMessage, clearMessage]);

  return (
    <Snackbar
      anchorOrigin={defaultAnchorOrigin}
      open={isOpen}
      onClose={handleCloseSnackbar}
      autoHideDuration={defaultAutoHideDuration}
      data-testid='popup-message'
    >
      <Alert severity={localMessage?.severity} action={<Action handleClose={handleCloseSnackbar} />}>
        {localMessage?.text}
      </Alert>
    </Snackbar>
  );
};
